import { usePageTitle } from "../hooks/usePageTitle";
import Footer from "../components/Footer";
import HeroSection from "../components/HomepageSection/HeroSection";
import InsuranceLinesSection from "../components/HomepageSection/InsuranceLinesSection";
import WhyChoosePaladinSection from "../components/HomepageSection/WhyChoosePaladinSection";
import FourStepsSection from "../components/HomepageSection/FourStepsSection";
import PartnershipSection from "../components/HomepageSection/PartnershipSection";
import TestimonialSection from "../components/HomepageSection/TestimonialSection";

export default function Homepage() {
  usePageTitle();
  return (
    <div className="min-h-screen bg-white-pure text-black-deep">
      <main>
        <HeroSection />
        <InsuranceLinesSection />
        <WhyChoosePaladinSection />
        <FourStepsSection />
        <PartnershipSection />
        <TestimonialSection />
      </main>
      <footer><Footer /></footer>
    </div>
  );
}